import { addCard, removeCard } from './payment.types'

export const addPaymentCard = card => ({ type: addCard, payload: card })
export const removePaymentCard = card => ({ type: removeCard, payload: card })
